import Link from "next/link";

export default function HighlightedLink({href, text}:{href:string, text:string}){
    return(
        <Link href={href} className='text-secondary'>{text}</Link>
    )
}